import EventAvailableIcon from '@mui/icons-material/EventAvailableOutlined';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import UploadIcon from '@mui/icons-material/FileUploadOutlined';
import FolderDeleteOutlinedIcon from '@mui/icons-material/FolderDeleteOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import {Divider, Menu, useTheme} from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import {bool, element, func, node, object, oneOf, oneOfType} from 'prop-types';

import {EXPORT_FORMATS} from '../../../const';
import useBudget from '../../../hooks/providers/useBudget';

const SpreadsheetMenu = ({isOpen, onClose, anchorEl}) => {
  const theme = useTheme();

  const {
    isCreatingOrUpdatingBudget,
    isExportingBudgetToFile,
    setIsCreateOrUpdateBudgetFormOpen,
    setIsCreateBudgetForm,
    setIsDeleteBudgetDialogOpen,
    exportBudgetToFile,
    isImportingBudgetFromFile,
    setIsImportBudgetModalOpen,
    isDeletingBudget
  } = useBudget();

  const handleExcelExport = () => {
    onClose();
    exportBudgetToFile(EXPORT_FORMATS.XLSX);
  };

  const handleImportBudgetFile = () => {
    setIsImportBudgetModalOpen(true);
    onClose();
  };

  return (
    <Menu
      open={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <MenuItem disabled>
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <SettingsIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Modifier les paramètres du budget</ListItemText>
      </MenuItem>

      <Divider />

      <MenuItem
        disabled={isCreatingOrUpdatingBudget}
        onClick={() => {
          onClose();
          setIsCreateOrUpdateBudgetFormOpen(true);
          setIsCreateBudgetForm(false);
        }}
      >
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <EventAvailableIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Ajouter une année</ListItemText>
      </MenuItem>

      <MenuItem onClick={() => setIsDeleteBudgetDialogOpen(true)} disabled={isDeletingBudget}>
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <FolderDeleteOutlinedIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Supprimer un budget</ListItemText>
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleImportBudgetFile} disabled={isImportingBudgetFromFile}>
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <UploadIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Importer depuis un fichier</ListItemText>
      </MenuItem>

      <MenuItem onClick={handleExcelExport} disabled={isExportingBudgetToFile}>
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <DownloadIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Exporter en Microsoft Excel</ListItemText>
      </MenuItem>

      <MenuItem disabled>
        <ListItemIcon sx={{color: theme.palette.primary.main}}>
          <DownloadIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText>Exporter en PDF</ListItemText>
      </MenuItem>
    </Menu>
  );
};

SpreadsheetMenu.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  anchorEl: oneOfType([object, element, node, oneOf([null])])
};

export default SpreadsheetMenu;
